<template>
  <div class="flight-segment">
    <div class="segment">
      <div class="time">
        <div class="over-time" v-if="showDepDate && flightItem.depPlusDay">{{ flightItem.depDate || '' }}</div>
        {{ flightItem.depTime }}
      </div>
      <div class="airport">{{ flightItem.depAirportName }}机场 {{ flightItem.depAirportTerm || '' }}</div>
    </div>
    <div class="during">
      <!-- 直飞 -->
      <template v-if="!flightItem.stopTransitAirports || flightItem.stopTransitAirports.length == 0">
        <div class="top-part">{{ flightItem.stopAirport ? `经停 ${ flightItem.stopAirport.cityName }` : '直飞'}}</div>
        <div class="center-part">
          <span class="during-line" style="background: #e4e4e4"></span>
          <img class="during-air" src="@/assets/ticket-air.png" />
        </div>
        <div class="bottom-part" >{{ flightItem.stopAirport ? flightItem.stopAirport.duration : flightItem.duration }}</div>
      </template>
      <!-- 中转经停 -->
      <template v-else>
        <div class="stop-airport">
          <div class="during-line" style="background: #e4e4e4"></div>
          <div class="stop-list">
            <div class="stop-item" v-for="(item, stopIndex) in flightItem.stopTransitAirports" :key="stopIndex">
              <div class="top-part">{{ item.cityName }}</div>
              <div class="center-part">{{ formatTypeText(item.type) }}</div>
              <div class="bottom-part">{{ item.duration }}</div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="segment arr-segment">
      <div class="time">
        <!--  -->
        <div class="over-time" v-if="flightItem.plusDay || flightItem.arrPlusDay">{{ flightItem.arrDate || '' }}</div>
        {{ flightItem.arrTime }}
      </div>
      <div class="airport">{{ flightItem.arrAirportName }}机场 {{ flightItem.arrAirportTerm || '' }}</div>
    </div>
  </div>
</template>

<script>

const stopTypeShowFieldMap = {
  '中转': 'duration',
  '经停': 'type'
}

export default {
  name: "Segment",
  props: {
    flightItem: {
      type: Object,
      default: () => ({})
    },
    // 是否展示出发的日期
    showDepDate: {
      type: Boolean,
      default: false
    },
    // 是否展示到达日期
    showArrDate: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    // bottomTextShow(item) {
    //   return item[stopTypeShowFieldMap[item.type]] || item.type
    // },
    formatTypeText(type) {
      if(type === '中转') return '转'
      if(type === '经停') return '经'
    }
  }
};
</script>

<style lang="less" scoped>
.flight-segment {
  display: flex;
  align-items: center;
  .segment {
    width: 150px;
    .time {
      font-size: 28px;
      text-align: center;
      color: #4d4e4e;
      position: relative;
      .over-time {
        width: 100%;
        text-align: center;
        font-size: 12px;
        position: absolute;
        top: -15px;
        color: #aaaaaa;
      }
    }
    .airport {
      text-align: center;
      color: #4d4e4e;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 24px 6px 0;
    }
  }
  .during {
    width: 200px;
    // height: fit-content;
    .top-part,
    .bottom-part {
      font-size: 12px;
      // padding-top: 5px;
      text-align: center;
      color: #aaaaaa;
    }

    .center-part {
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .during-air {
        width: 32px;
        height: 32px;
        position: absolute;
        top: 6px;
      }
      .during-line {
        width: 100%;
        height: 1px;
        background: #7f7e7c;
      }
    }
  }


  .stop-airport {
    position: relative;
    .during-line {
      width: 100%;
      height: 1px;
      background: #7f7e7c;
    }
    .stop-list {
      display: flex;
      gap: 30px;
      width: 100%;
      justify-content: center;
      box-sizing: border-box;
      position: absolute;
      top: -29px;

      .stop-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 70px;
        text-align: center;
      }

      .center-part {
        width: 16px;
        height: 16px;
        border-radius: 16px;
        border: 1px solid #ccc;
        margin: 4px 0;
        background: #fff;
        font-size: 10px;
        color: #ccc;
        line-height: 16px;
        text-align: center;
      }
    }
  }
}
</style>
